/*
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2024-01-05 11:56:27
 */
import request from '@/utils/service'

export function shopEquListApi(data) {
  return request({
    url: '/business/devices',
    method: 'get',
    params: data
  })
}

export function partnerEquListApi(data) {
  return request({
    url: '/partner/devices',
    method: 'post',
    params: data
  })
}

export function addEquBatchApi(data) {
  return request({
    url: '/prodBatch/add',
    method: 'post',
    data
  })
}

export function batchListApi(data) {
  return request({
    url: '/prodBatch/list',
    method: 'get',
    params: data
  })
}

export function equListApi(data) {
  return request({
    url: '/device/list',
    method: 'get',
    params: data
  })
}

export function otaListApi(data) {
  return request({
    url: '/deviceOtaVersion/list',
    method: 'get',
    params: data
  })
}

export function addOtaApi(data) {
  return request({
    url: '/deviceOtaVersion/add',
    method: 'post',
    data
  })
}

export function otaUpgradeApi(data) {
  return request({
    url: '/device/triggerOtaUpdate',
    method: 'post',
    data
  })
}

export function siteOtaUpgradeApi(data) {
  return request({
    url: '/device/triggerOtaUpdateByStore',
    method: 'post',
    data
  })
}
